import { userSession } from 'state/session';
import { voipMasterTabId } from 'state/session/voipClaim';
import { user } from 'utils/auth/user';
import { voipRtcConnection } from 'utils/ui/rtc';
import { hasLiveMasterPeer } from 'utils/ui/voipRemotes';

/**
 * AVS-4482: a 3D stream loss in a VOIP standby stays in that tab while the dealer's elected master tab
 * is connected, because that tab carries the session. A standby never hosts, so its loss ends nothing for
 * anyone else. Another standby of the dealer is no proof: only the master's own live row counts. The
 * master, hidden or not, hosts the stream; its loss, a lone tab's, or a standby whose master is gone
 * still ends 3D for the session as before (host hand-off: AVS-4485).
 */
export function isDeckFailureLocal(): boolean {
  const session = userSession();
  if (!user.isDealer || !session.isVoipStandby) return false;
  const masterSlotId = voipMasterTabId(session.get('voipMasters')?.[user.userPseudonym]);
  const remotes = Object.values(voipRtcConnection?.store.get('remoteConnections') ?? {});
  return hasLiveMasterPeer(remotes, masterSlotId);
}

const LOCAL_DECK_RETRY_DELAYS_MS = [5000, 10000, 20000];

/**
 * AVS-4482: how long a visible tab waits before it re-mounts a locally failed deck, by retry number.
 * `undefined` once the retries are spent: the deck then waits for the dealer (visibility, a new stream, take over).
 */
export function localDeckRetryDelay(attempt: number): number | undefined {
  return LOCAL_DECK_RETRY_DELAYS_MS[attempt];
}
